<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="list">全部外部平台记录明细</el-menu-item>
          <el-menu-item index="add" >外部平台记录批次数据</el-menu-item>
          <el-menu-item index="invoice" >全部开票记录</el-menu-item>
          
        </el-menu>
      </div>
      <div class="content-wrap">
        <platform-list v-if="activeIndex == 'list'"></platform-list>
        <platform-batch v-if="activeIndex == 'add'" @toDeliveryList="dealToDeliveryList"></platform-batch>
        <platform-invoice v-if="activeIndex == 'invoice'" @toDeliveryList="dealToDeliveryList"></platform-invoice>
      </div>
    </div>
  </div>
</template>

<script>
import platformList from "./component/list";
import platformBatch from "./component/batchlist";
import platformInvoice from "./component/invoice";
import { mapGetters } from "vuex";

export default {
    computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  data() {
    return {
      activeIndex: "list",
      queryData: {}
    };
  },
  components: {
    platformList,
    platformBatch,
    platformInvoice
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    dealToDeliveryList() {
      this.activeIndex = 'list';
    }
  }
}
</script>